import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import type {RGBA} from '@Utils/color.util';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {BaseRemovecolorColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-removecolor-color-option';
import {REMOVE_COLOR_TOLERANCE_DISPLAY_RANGE, REMOVE_COLOR_TOLERANCE_RANGE} from './base-remove-color-option.types';

interface BaseRemoveColorOptionProps {
  removeColorValue: RGBA;
  removeColorThickness: number;
  removeColor: boolean;

  onClickColorFill(): void;

  onToggleRemoveColor(): void;

  updateTolerance(updatedValue: number, undoable?: boolean): void;
}

export function BaseRemoveColorOption({...props}: BaseRemoveColorOptionProps): ReactElement<any> | null {
  const onClickHandler = (): void => {
    props.onToggleRemoveColor();
  };

  const getRemoveColorFillOption = (): ReactElement<any> => {
    return (
      <BaseRemovecolorColorOption
        removeColorValue={props.removeColorValue}
        onClickColorFill={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  const onToleranceChangeHandler = (updatedValue: number): void => {
    props.updateTolerance(updatedValue, false);
  };
  const onToleranceChangeEndedHandler = (updatedValue: number): void => {
    props.updateTolerance(updatedValue);
  };

  const getRemoveColorToleranceOption = (): ReactElement<any> => {
    return (
      <ContextualMenuSliderOptions
        id="remove-color-thickness-option"
        value={props.removeColorThickness}
        label={window.i18next.t('pmwjs_thickness')}
        range={REMOVE_COLOR_TOLERANCE_RANGE}
        transformDisplay={REMOVE_COLOR_TOLERANCE_DISPLAY_RANGE}
        onChange={onToleranceChangeHandler}
        onChangeEnded={onToleranceChangeEndedHandler}
      />
    );
  };

  const getSubOptions = (): ReactElement<any> | null => {
    if (!props.removeColor) {
      return null;
    }

    return (
      <>
        {getRemoveColorFillOption()}
        {getRemoveColorToleranceOption()}
      </>
    );
  };

  return (
    <ContextualMenuToggleOption id="item-remove-color-option" label={window.i18next.t('pmwjs_remove_color')} isChecked={props.removeColor} onClick={onClickHandler}>
      {getSubOptions()}
    </ContextualMenuToggleOption>
  );
}
